import { shorten } from "@/util/util";
import CHAINS from "lib/chains";
import { Chain } from "lib/types";

export enum ScannerType {
  Address,
  Tx,
  Block,
  BeaconSlot,
}

const ScannerLink = ({
  value,
  chain,
  type,
  shorten: shortenAddress = false,
}: {
  value: string;
  type: ScannerType;
  chain: Chain | undefined;
  shorten?: boolean;
}) => {
  let url = undefined;
  let parsedValue = value;
  if (chain !== undefined) {
    url = "";
    if (type === ScannerType.Address) {
      parsedValue = value.length === 42 ? value : "0x" + value.slice(26);
      url = CHAINS[chain]?.scanUrl + "address/";
    } else if (type === ScannerType.Tx) {
      url = CHAINS[chain]?.scanUrl + "tx/";
    } else if (type === ScannerType.Block) {
      url = CHAINS[chain]?.scanUrl + "block/";
    } else {
      if (chain === "gnosis") {
        // Gnosis uses old beaconcha.in version
        url = (CHAINS[chain]?.beaconScanUrl || "") + "block/";
      } else {
        url = (CHAINS[chain]?.beaconScanUrl || "") + "slot/";
      }
    }
    url += parsedValue;
  }

  return (
    <a
      href={url}
      className="font-mono text-succinct-teal-50 hover:underline"
      title={value}
      target="_blank"
      rel="noreferrer"
    >
      {shortenAddress ? shorten(parsedValue, 6, 4) : parsedValue}
    </a>
  );
};

export default ScannerLink;
